import { detectLocale } from '@quintoandar/js-intl';

import { AnnouncementStepsLoadable } from 'containers/AnnouncementSteps/AnnouncementStepsLoadable';
import ExternalArea from 'containers/Checklist/ExternalArea';
import House from 'containers/Checklist/House';

import ROUTES, { routesNames } from './constants';

const createAnnouncementSteps = () => {
  const routes = [
    {
      path: ROUTES.VIDEOS(),
      name: routesNames.videos,
      component: AnnouncementStepsLoadable,
      exact: true,
    },
    {
      path: ROUTES.PHOTOS_MANAGER(),
      name: routesNames.photosManager,
      component: AnnouncementStepsLoadable,
      exact: true,
    },
    {
      path: ROUTES.NEW_CHECKLIST(),
      name: routesNames.newChecklist,
      component: AnnouncementStepsLoadable,
      exact: true,
    },
    {
      path: ROUTES.NEW_CHECKLIST_EXTERNAL_AREA(),
      name: routesNames.newChecklist,
      component: ExternalArea,
      exact: true,
    },
    {
      path: ROUTES.NEW_CHECKLIST_HOUSE(),
      name: routesNames.newChecklist,
      component: House,
      exact: true,
    },
  ];

  const locale = detectLocale();

  if (locale !== 'pt-BR') {
    routes.push({
      path: ROUTES.PHOTOS_MANAGER_PHOTOSPHERE(),
      name: routesNames.photosManagerPhotosphere,
      component: AnnouncementStepsLoadable,
      exact: true,
    });
  }

  return routes;
};

export default createAnnouncementSteps;
